var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13C16.5 10.7909 14.7091 9 12.5 9C10.2909 9 8.5 10.7909 8.5 13V15C8.5 17.2091 10.2909 19 12.5 19C14.7091 19 16.5 17.2091 16.5 15V13Z",
    fill: "#70A9ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 23H13.5C15.6217 23 17.6566 23.8429 19.1569 25.3431C20.6571 26.8434 21.5 28.8783 21.5 31V34C21.5 34.2652 21.3946 34.5196 21.2071 34.7071C21.0196 34.8946 20.7652 35 20.5 35H4.5C4.23478 35 3.98043 34.8946 3.79289 34.7071C3.60536 34.5196 3.5 34.2652 3.5 34V31C3.5 28.8783 4.34285 26.8434 5.84315 25.3431C7.34344 23.8429 9.37827 23 11.5 23Z",
    fill: "#70A9ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 13C40.5 10.7909 38.7091 9 36.5 9C34.2909 9 32.5 10.7909 32.5 13V15C32.5 17.2091 34.2909 19 36.5 19C38.7091 19 40.5 17.2091 40.5 15V13Z",
    fill: "#B3D9FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 23H37.5C39.6217 23 41.6566 23.8429 43.1569 25.3431C44.6571 26.8434 45.5 28.8783 45.5 31V34C45.5 34.2652 45.3946 34.5196 45.2071 34.7071C45.0196 34.8946 44.7652 35 44.5 35H28.5C28.2348 35 27.9804 34.8946 27.7929 34.7071C27.6054 34.5196 27.5 34.2652 27.5 34V31C27.5 28.8783 28.3429 26.8434 29.8431 25.3431C31.3434 23.8429 33.3783 23 35.5 23Z",
    fill: "#B3D9FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 17C28.5 14.7909 26.7091 13 24.5 13C22.2909 13 20.5 14.7909 20.5 17V19C20.5 21.2091 22.2909 23 24.5 23C26.7091 23 28.5 21.2091 28.5 19V17Z",
    fill: "#417ACE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 27H25.5C27.6217 27 29.6566 27.8429 31.1569 29.3431C32.6571 30.8434 33.5 32.8783 33.5 35V38C33.5 38.2652 33.3946 38.5196 33.2071 38.7071C33.0196 38.8946 32.7652 39 32.5 39H16.5C16.2348 39 15.9804 38.8946 15.7929 38.7071C15.6054 38.5196 15.5 38.2652 15.5 38V35C15.5 32.8783 16.3429 30.8434 17.8431 29.3431C19.3434 27.8429 21.3783 27 23.5 27Z",
    fill: "#417ACE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.0e07de8fa25699897e5088cb7f7f69c4.svg";
export { ForwardRef as ReactComponent };